import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserRoutingModule } from 'root/user/user-routing.module';
import { SharedModule } from 'shared/shared.module';
import { AssignedProjectsComponent } from './assigned-projects/assigned-projects.component';
import { AssignedStatusesComponent } from './assigned-statuses/assigned-statuses.component';
import { UserComponent } from './user/user.component';

@NgModule({
  declarations: [
    UserComponent,
    AssignedProjectsComponent,
    AssignedStatusesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UserRoutingModule,
  ],
  exports: [UserComponent],
})
export class UserModule {
}
